import Cookies from 'js-cookie'
import {env} from '~/config/env.mjs'
import {unreachableCase} from '~/design-system/utils'

export function getCanSeePerksCookieKey() {
  const CAN_SEE_PERKS_COOKIE_KEY = 'canSeePerks'

  switch (env.NEXT_PUBLIC_BACKEND_SOURCE) {
    case 'production':
      return CAN_SEE_PERKS_COOKIE_KEY
    case 'staging':
    case 'localhost':
    case 'mock':
      return `${CAN_SEE_PERKS_COOKIE_KEY}_${env.NEXT_PUBLIC_BACKEND_SOURCE}`
    // NOTE: The following cases do not have a cookie key because they don't communicate with the backend
    default:
      unreachableCase(env.NEXT_PUBLIC_BACKEND_SOURCE)
      return ''
  }
}

export function hasCanSeePerksCookie() {
  const cookieKey = getCanSeePerksCookieKey()
  const canSeePerks = cookieKey ? Cookies.get(cookieKey) : false
  return !!canSeePerks
}
